import { useMemo } from "react";
import { palette } from "./palette";
import { merge } from "lodash";
import { CssBaseline, ThemeProvider, createTheme, } from "@mui/material";
import { componentsOverrides } from "./overrides";
import { customShadows } from "./custom-shadows";
import { shadows } from "./shadows";
import { typography } from "./typography";
import React from "react";
export default function AppThemeProvider({ children }) {
    const baseOption = useMemo(() => ({
        palette: palette("light"),
        shadows: shadows("light"),
        customShadows: customShadows("light"),
        typography,
        shape: { borderRadius: 8 },
    }), []);
    // ✅ Don't mutate baseOption
    const memoizedValue = useMemo(() => merge({}, baseOption), [baseOption]);
    const theme = createTheme(memoizedValue);
    // ✅ Also don't mutate theme.components if you can help it
    theme.components = merge({}, componentsOverrides(theme));
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(CssBaseline, null),
        children));
}
